module.exports = "data:image/gif;base64,R0lGODlhEAAQALMAAAAAAP///wCEAMbexg+BBE11FntsJLhhNfVVR+FpXqWlpf///wAAAAAAAAAAAAAAACH5BAEAAAsALAAAAAAQABAAAAQtcMlJq7046zrElp3yLYK4IceBnEi7WqXUZorgGUii2UIx7wKC6weLDWmjZDICADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/approvedwithcomment.gif
// module id = hVRu
// module chunks = 1